<template>
  <Nav />
  <div class="container">
    <div class="fila-container">
      <div class="fila-header d-flex align-items-center gap-3">
        <a href="#" class="h3" @click.prevent="goBack">
          <i class="bi bi-arrow-left"></i>
        </a>
        <div>
          <h1>Fila de processamento de arquivos prévios</h1>
        </div>
      </div>

      <!-- Filtros -->
      <div class="fila-filters mb-4">
        <div class="row g-3">
          <div class="col-md-2">
            <label class="form-label small fw-semibold text-muted text-uppercase mb-1">Status</label>
            <select class="form-select form-select-sm" v-model="filters.status">
              <option value="">Todos</option>
              <option value="pendente">Pendente</option>
              <option value="processando">Processando</option>
              <option value="processado">Processado</option>
              <option value="ignorado">Ignorado</option>
              <option value="erro">Erro</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label small fw-semibold text-muted text-uppercase mb-1">Município</label>
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Nome do município"
              v-model="filters.municipio"
            />
          </div>
          <div class="col-md-2">
            <label class="form-label small fw-semibold text-muted text-uppercase mb-1">Cód. IBGE</label>
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Ex: 3550308"
              v-model="filters.cod_ibge"
            />
          </div>
          <div class="col-md-1">
            <label class="form-label small fw-semibold text-muted text-uppercase mb-1">Entregável</label>
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Ex: MSC"
              v-model="filters.entregavel"
            />
          </div>
          <div class="col-md-2">
            <label class="form-label small fw-semibold text-muted text-uppercase mb-1">De</label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filters.criado_em_inicio"
            />
          </div>
          <div class="col-md-2">
            <label class="form-label small fw-semibold text-muted text-uppercase mb-1">Até</label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filters.criado_em_fim"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 d-flex gap-2">
            <button class="btn btn-secondary btn-sm px-4" @click="applyFilters">
              <i class="bi bi-funnel me-1"></i>Filtrar
            </button>
            <button class="btn btn-outline-secondary btn-sm px-3" @click="clearFilters">
              <i class="bi bi-x-circle me-1"></i>Limpar
            </button>
          </div>
        </div>
      </div>

      <!-- Tabela -->
      <div class="fila-body">
        <div class="table-responsive">
          <table class="table fila-table">
            <thead>
              <tr>
                <th scope="col">Município</th>
                <th scope="col">Cód. IBGE</th>
                <th scope="col">Exercício</th>
                <th scope="col">Entregável</th>
                <th scope="col">Período</th>
                <th scope="col">Usuário</th>
                <th scope="col">Status</th>
                <th scope="col">Criado em</th>
                <th scope="col">Processado em</th>
                <th scope="col" class="actions-col">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="10" class="text-center text-muted py-4">
                  <span class="spinner-border spinner-border-sm me-2"></span>Carregando...
                </td>
              </tr>
              <tr v-else-if="records.length === 0">
                <td colspan="10" class="text-center text-muted py-4">Nenhum registro encontrado.</td>
              </tr>
              <tr v-for="record in records" :key="record.id" v-else>
                <td>{{ record.uf }} - {{ record.municipio }}</td>
                <td>{{ record.cod_ibge }}</td>
                <td>{{ record.exercicio }}</td>
                <td>{{ record.entregavel }}</td>
                <td>{{ record.periodo }}</td>
                <td class="usuario-col" :title="record.email_usuario_upload">
                  {{ record.nome_usuario_upload || record.email_usuario_upload || '—' }}
                </td>
                <td>
                  <span class="badge" :class="statusBadgeClass(record.status)">
                    {{ record.status }}
                  </span>
                </td>
                <td>{{ formatDate(record.criado_em) }}</td>
                <td>{{ formatDate(record.processado_em) }}</td>
                <td class="actions-col">
                  <button class="btn-icon" @click="openDetailModal(record)" title="Visualização detalhada">
                    <i class="bi bi-eye text-primary"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginação -->
        <div class="fila-pagination d-flex justify-content-between align-items-center mt-3" v-if="total > 0">
          <span class="text-muted small">
            Exibindo {{ records.length }} de {{ total }} registros
          </span>
          <div class="d-flex gap-2">
            <button
              class="btn btn-outline-secondary btn-sm"
              :disabled="page === 1"
              @click="changePage(page - 1)"
            >Anterior</button>
            <span class="btn btn-sm disabled">{{ page }}</span>
            <button
              class="btn btn-outline-secondary btn-sm"
              :disabled="page * limit >= total"
              @click="changePage(page + 1)"
            >Próxima</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Visualização Detalhada -->
  <div class="modal fade" id="detalheProcessamentoModal" tabindex="-1" ref="detalheModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" v-if="selectedRecord">
        <div class="modal-header">
          <h5 class="modal-title">Visualização Detalhada</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">ID</span>
                <span class="detail-value">{{ selectedRecord.id }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Status</span>
                <span class="badge" :class="statusBadgeClass(selectedRecord.status)">
                  {{ selectedRecord.status }}
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Município</span>
                <span class="detail-value">{{ selectedRecord.municipio }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">UF</span>
                <span class="detail-value">{{ selectedRecord.uf }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Cód. IBGE</span>
                <span class="detail-value">{{ selectedRecord.cod_ibge }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Exercício</span>
                <span class="detail-value">{{ selectedRecord.exercicio }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Entregável</span>
                <span class="detail-value">{{ selectedRecord.entregavel }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Período</span>
                <span class="detail-value">{{ selectedRecord.periodo }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Periodicidade</span>
                <span class="detail-value">{{ selectedRecord.periodicidade_normalizada }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Mês</span>
                <span class="detail-value">{{ selectedRecord.mes }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Protocolo</span>
                <span class="detail-value detail-mono">{{ selectedRecord.protocolo || '—' }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Formato do Arquivo</span>
                <span class="detail-value">{{ selectedRecord.arquivo_formato_origem || '—' }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Usuário Upload</span>
                <span class="detail-value">{{ selectedRecord.nome_usuario_upload || '—' }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Email Upload</span>
                <span class="detail-value">{{ selectedRecord.email_usuario_upload || '—' }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Email Feedback</span>
                <span class="detail-value">{{ selectedRecord.email_feedback || '—' }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Criado em</span>
                <span class="detail-value">{{ formatDate(selectedRecord.criado_em) }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Processado em</span>
                <span class="detail-value">{{ selectedRecord.processado_em ? formatDate(selectedRecord.processado_em) : '—' }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Run ID</span>
                <span class="detail-value detail-mono">{{ selectedRecord.run_id || '—' }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Arquivo ID</span>
                <span class="detail-value detail-mono">{{ selectedRecord.arquivo_id || '—' }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-field">
                <span class="detail-label">Pasta ID</span>
                <span class="detail-value detail-mono">{{ selectedRecord.pasta_id || '—' }}</span>
              </div>
            </div>
            <div class="col-12" v-if="selectedRecord.razao">
              <div class="detail-field">
                <span class="detail-label">Razão</span>
                <span class="detail-value">{{ selectedRecord.razao }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import axiosApi from "@/axios";
import { mapState, mapActions } from "vuex";

export default {
  name: "FilaProcessamentoArquivosPrevios",
  components: { Nav },
  data() {
    return {
      records: [],
      total: 0,
      page: 1,
      limit: 50,
      loading: false,
      selectedRecord: null,
      filters: {
        status: "",
        municipio: "",
        cod_ibge: "",
        entregavel: "",
        criado_em_inicio: "",
        criado_em_fim: "",
      },
    };
  },
  computed: {
    ...mapState(["user", "isAuthLoading"]),
  },
  async created() {
    try {
      await this.validateToken();

      if (this.isAuthLoading) {
        const checkAuth = () => {
          if (!this.isAuthLoading) {
            if (!this.user || this.user.role !== "admin") {
              this.$router.push("/");
            } else {
              this.fetchRecords();
            }
          } else {
            setTimeout(checkAuth, 100);
          }
        };
        checkAuth();
      } else {
        if (!this.user || this.user.role !== "admin") {
          this.$router.push("/");
        } else {
          this.fetchRecords();
        }
      }
    } catch {
      this.$router.push("/login");
    }
  },
  methods: {
    ...mapActions(["validateToken"]),

    goBack() {
      this.$router.push("/filas");
    },

    async fetchRecords() {
      this.loading = true;
      try {
        const params = {
          page: this.page,
          limit: this.limit,
          ...Object.fromEntries(
            Object.entries(this.filters).filter(([, v]) => v !== "")
          ),
        };
        const response = await axiosApi.get("/api/filas/processamento-arquivos-previos", { params });
        this.records = response.data.data.data;
        this.total = response.data.data.total;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    applyFilters() {
      this.page = 1;
      this.fetchRecords();
    },

    clearFilters() {
      this.filters = {
        status: "",
        municipio: "",
        cod_ibge: "",
        entregavel: "",
        criado_em_inicio: "",
        criado_em_fim: "",
      };
      this.page = 1;
      this.fetchRecords();
    },

    changePage(newPage) {
      this.page = newPage;
      this.fetchRecords();
    },

    normalizePeriodicidade(periodicidade) {
      if (periodicidade == "Q") return "Quadrimestral";
      if (periodicidade == "S") return "Semestral";
      if (periodicidade == "A") return "Anual";
      if (periodicidade == "B") return "Bimestral";
      if (periodicidade == "M") return "Mensal";
      return periodicidade ?? "-";
    },

    openDetailModal(record) {
      this.selectedRecord = {
        ...record,
        periodicidade_normalizada: this.normalizePeriodicidade(record.periodicidade),
      };
      this.$nextTick(() => {
        const modal = new window.bootstrap.Modal(this.$refs.detalheModal);
        modal.show();
      });
    },

    statusBadgeClass(status) {
      const classes = {
        pendente:    "bg-warning text-dark",
        processando: "bg-primary",
        processado:  "bg-success",
        ignorado:    "bg-secondary",
        erro:        "bg-danger",
      };
      return classes[status] || "bg-secondary";
    },

    formatDate(value) {
      if (!value) return "—";
      // API já envia horário local do Brasil (sem conversão), apesar do
      // sufixo "Z" enganoso — extraímos os componentes literais da string
      // ao invés de deixar o Date() reinterpretar como UTC.
      const match = String(value).match(
        /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/
      );
      if (!match) return value;
      const [, year, month, day, hour, minute] = match;
      return `${day}/${month}/${year} ${hour}:${minute}`;
    },
  },
};
</script>

<style scoped>
.fila-container {
  padding: 20px 0;
  min-width: 1300px;
}

@media (max-width: 1260px) {
  .fila-container {
    min-width: 0;
    width: 100%;
  }
}

.fila-header h1 {
  font-size: 2rem;
  font-weight: 600;
  color: var(--azul-final);
}

.fila-table thead th {
  font-weight: 700;
  color: var(--azul-final);
  border-bottom: 2px solid #dee2e6;
}

.fila-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
}

.fila-table td {
  vertical-align: middle;
  color: #444;
}

.fila-table th,
.fila-table td {
  white-space: nowrap;
}

.usuario-col {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.actions-col {
  text-align: right;
  width: 60px;
}

.btn-icon {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1em;
}

.btn-icon:hover {
  opacity: 0.7;
}

.detail-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detail-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.detail-value {
  font-size: 0.9rem;
  color: #333;
}

.detail-mono {
  font-family: monospace;
  font-size: 0.8rem;
}
</style>
